import {
  convertFile,
  convertFolder,
  File,
  Folder,
  Id,
  RepositoryResponse,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useFileDetails(
  fileId?: Id,
  enabled?: boolean,
  retry?: boolean
) {
  const { server } = useServer()
  return useQuery<File>({
    queryKey: keys.file(fileId),
    queryFn: fetchFileDetails,
    enabled: enabled && !!fileId,
    retry: retry,
  })

  async function fetchFileDetails() {
    const url = `/v2/chat/repository/files/${fileId}`
    const response = await server.get<RepositoryResponse.File>(url)
    return convertFile(response)
  }
}

export function useFolderDetails(folderId?: Id, enabled?: boolean) {
  const { server } = useServer()
  return useQuery<Folder>({
    queryKey: keys.folder(folderId),
    queryFn: fetchFolderDetails,
    enabled: enabled && !!folderId,
  })

  async function fetchFolderDetails() {
    const url = `/v2/chat/repository/folders/${folderId}`
    const response = await server.get<RepositoryResponse.Folder>(url)
    return convertFolder(response)
  }
}
